<app-header  ></app-header>

<div class="long-title centered text-center"  >
    <h3>Perfil del usuario.</h3>
</div>

<br/>

<!--Cambiar datos del usuario-->
<div class="col-lg-11 centered text-center"  >
  <div class="col-md-5 offset-md-4">
        <div class="form">
                <div class="dx-fieldset">
                    <div class="dx-field" *ngIf="messageChangeUser.length > 0">
                        <div class="dx-field-label">
                                <h5>{{messageChangeUser}} </h5>
                            </div>  
                    </div>
            </div>
        </div>
        
    <form   #theForm="ngForm" action="your action" (submit)="onFormSubmit($event)"
    (keydown.enter)="$event.preventDefault()"*ngIf="messageChangeUser.length ==0">
    <div class="form">
        <div class="dx-fieldset">
            <div class="dx-field">
                <div class="dx-field-label">Nombre del usuario</div>
                <div class="dx-field-value">
                    <dx-text-box [(value)]="creds.userName" 
                        placeholder="Nombre del usuario">
                        <dx-validator>
                         <dxi-validation-rule type="required"
                          message="Nombre requerido"></dxi-validation-rule>
                       </dx-validator>
                    </dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">Correo del usuario</div>
                <div class="dx-field-value">
                    <dx-text-box placeholder="Correo electrónico"
                        [(value)]="creds.email">
                     <dx-validator>
                         <dxi-validation-rule type="required" message="Correo requerido"></dxi-validation-rule>
                       </dx-validator>
                    </dx-text-box>
                </div>
            </div>
            <!-- <div class="dx-field">
                <div class="dx-field-label">Contraseña</div>
                <div class="dx-field-value">
                    <dx-text-box
                        mode="password"
                        [(value)]="creds.newPassword">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="La contraseña es requerida"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div> -->
            <!-- <div class="dx-field">
                <div class="dx-field-label">Confirmar contraseña</div>
                <div class="dx-field-value">
                    <dx-text-box mode="password"  [(value)]="creds.confirmPassword">
                        <dx-validator>
                            <dxi-validation-rule type="required"
                            message="La confirmación de la contraseña es requerida"></dxi-validation-rule>
                            <dxi-validation-rule 
                            type="compare" 
                            [comparisonTarget]="passwordComparison"
                                message="La contraseña y la confirmación no son iguales"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div> -->
        </div>
        <div class="dx-fieldset">
            <dx-validation-summary id="summary"></dx-validation-summary>
            <dx-button  id="button" text="Guardar" type="success" 
                        [useSubmitBehavior]="true"
                        [disabled]="theForm.invalid">
            </dx-button>
            
        </div>
        <!-- <div class="dx-fieldset">
            <dx-button  id="button" text="Cambiar contraseña" type="success" 
                [useSubmitBehavior]="true"
                [disabled]="theForm.invalid">
            </dx-button>
        </div> -->
    
    </div> 
    </form>
  </div>
</div>



<!-- Cambiar contraseña -->

<!-- <div class="col-lg-11 centered text-center"  >
    <div class="col-md-5 offset-md-4">
      <form   #theForm="ngForm" action="your action" (submit)="onFormSubmit($event)"
      (keydown.enter)="$event.preventDefault()">
      <div class="form">
          <div class="dx-fieldset">
              <div class="dx-field">
                  <div class="dx-field-label">Nombre del usuario</div>
                  <div class="dx-field-value">
                      <dx-text-box [(value)]="creds.userName" 
                          placeholder="Nombre del usuario">
                          <dx-validator>
                           <dxi-validation-rule type="required"
                            message="Nombre requerido"></dxi-validation-rule>
                         </dx-validator>
                      </dx-text-box>
                  </div>
              </div>
              <div class="dx-field">
                  <div class="dx-field-label">Correo del usuario</div>
                  <div class="dx-field-value">
                      <dx-text-box placeholder="Correo electrónico"
                          [(value)]="creds.email">
                       <dx-validator>
                           <dxi-validation-rule type="required" message="Correo requerido"></dxi-validation-rule>
                         </dx-validator>
                      </dx-text-box>
                  </div>
              </div>
               <div class="dx-field">
                  <div class="dx-field-label">Contraseña</div>
                  <div class="dx-field-value">
                      <dx-text-box
                          mode="password"
                          [(value)]="creds.newPassword">
                          <dx-validator>
                              <dxi-validation-rule type="required" message="La contraseña es requerida"></dxi-validation-rule>
                          </dx-validator>
                      </dx-text-box>
                  </div>
              </div>  
                <div class="dx-field">
                  <div class="dx-field-label">Confirmar contraseña</div>
                  <div class="dx-field-value">
                      <dx-text-box mode="password"  [(value)]="creds.confirmPassword">
                          <dx-validator>
                              <dxi-validation-rule type="required"
                              message="La confirmación de la contraseña es requerida"></dxi-validation-rule>
                              <dxi-validation-rule 
                              type="compare" 
                              [comparisonTarget]="passwordComparison"
                                  message="La contraseña y la confirmación no son iguales"></dxi-validation-rule>
                          </dx-validator>
                      </dx-text-box>
                  </div>
              </div>  
          </div>
          <div class="dx-fieldset">
              <dx-validation-summary id="summary"></dx-validation-summary>
              <dx-button  id="button" text="Guardar" type="success" 
                          [useSubmitBehavior]="true"
                          [disabled]="theForm.invalid">
              </dx-button> 
          </div>  
      </div> 
      </form>
    </div>
  </div> -->
  
<app-footer></app-footer>